import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { TegelModule } from '@scania/tegel-angular-17';
import { IPaginatedFilters } from 'src/app/shared/architecture/envelopes';
import { BankService } from 'src/app/shared/services/core/bank.component.service';
import { ChangeDetectorRef } from '@angular/core';
import { NgxPaginationModule } from 'ngx-pagination';

@Component({
  selector: 'app-consulta-bancos',
  imports: [TegelModule, CommonModule, NgxPaginationModule],
  templateUrl: './consulta-bancos.component.html',
  styleUrl: './consulta-bancos.component.scss'
})
export class ConsultaBancosComponent implements OnInit{
  originalBanks: any[] = [];
  banks: any[];
  page = 1;
  pageSize = 10;
  searchText = '';
  private filtros:IPaginatedFilters = { paginationValue: '1', paginationSize: '10', columnKey: '', sortingDirection: '', query: ''};
  order = "id";

  constructor(private bankService: BankService, private cdr: ChangeDetectorRef){
    this.banks = [];
  }

  ngOnInit(): void {
    this.getAllBanks();
  }

  getAllBanks(){
    this.bankService.get().subscribe((result) => {
      if (result) {
        result.sort((a: any, b: any) => a.id - b.id);
        this.originalBanks = result;
        this.banks = result;
        this.cdr.detectChanges();
        console.log(this.banks);
      }
    });

  }

  onFilterEvent(event: any) {
    const rawValue = event?.detail?.query ?? event?.target?.query ?? '';
    const value = String(rawValue).trim().toLowerCase();

    if (!value) {
      this.banks = [...this.originalBanks];
      this.page = 1;
      return;
    }

    const digits = value.replace(/\D/g, '');

    this.banks = this.originalBanks.filter(f => {
      const idMatch = digits ? String(f.id).includes(digits) : false;
      const descMatch = f.banco?.toLowerCase().includes(value);

      return idMatch || descMatch;
    });

    this.page = 1;
  }

  onSortEvent(event: any) {
  const column = event.detail.columnKey;
  const direction = event.detail.sortingDirection; 

  if (!column || direction === 'none') {
    return; 
  }

  
  this.banks.sort((a: any, b: any) => {
    const dir = direction === 'desc' ? 1 : -1;

    if (a[column] > b[column]) return 1 * dir;
    if (a[column] < b[column]) return -1 * dir;
    return 0;
  });
}
}
